// extracted by mini-css-extract-plugin
export var active = "_cf-2";
export var recordingDot = "_cf-1";
export var recordingIndicator = "_cf-0";